export const PrivacyType = {
    PRIVATE: 'PRIVATE',
    PUBLIC: 'PUBLIC',
};
